import { Component, OnInit } from '@angular/core';
import { AuthService } from '@kodit/core/services';

@Component({
  selector: 'kodit-korisnik-page',
  templateUrl: './korisnik-page.component.html',
  styleUrls: ['./korisnik-page.component.scss']
})
export class KorisnikPageComponent implements OnInit {
  showCreateDialog = false;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {}

  handleOpenCreateDialog(): void {
    this.showCreateDialog = true;
  }
}
